import { Dispatch, SetStateAction } from "react"
import { legendInvalid, legendIconInvalid, legendInvalidRequired, legendIconInvalidRequired, legendValid, legendIconValid, legendValidRequired, legendIconValidRequired, legendValidInvalidRestart, legendIconValidInvalidRestart } from "../utils/legend.data.util"

export function evaluateLegendOptional(regex: RegExp, field: any, set_field: Dispatch<SetStateAction<any>>, container: string) {
  if (field.value.length === 0) {
    set_field({...field, valid: true})
    legendValidInvalidRestart(container)
  } else {
    if (regex.test(field.value)) {
      set_field({...field, valid: true})
      legendValid(container)
    } else {
      set_field({...field, valid: false})
      legendInvalid(container)
    }
  }
}

export function evaluateLegendOptionalIcon(regex: RegExp, field: any, set_field: Dispatch<SetStateAction<any>>, identifier: string, container: string) {
  if (field.value.length === 0) {
    set_field({...field, valid: true})
    legendIconValidInvalidRestart(identifier, container)
  } else {
    if (regex.test(field.value)) {
      set_field({...field, valid: true})
      legendIconValid(identifier, container)
    } else {
      set_field({...field, valid: false})
      legendIconInvalid(identifier, container)
    }
  }
}

export function evaluateLegendRequired(regex: RegExp, field: any, set_field: Dispatch<SetStateAction<any>>, container_1: string, container_2: string) {
  if (regex.test(field.value)) {
    set_field({...field, valid: true})
    legendValidRequired(container_1, container_2)
  } else {
    set_field({...field, valid: false})
    legendInvalidRequired(field.value, container_1, container_2)
  }
}

export function evaluateLegendRequiredIcon(regex: RegExp, field: any, set_field: Dispatch<SetStateAction<any>>, identifier: string, container_1: string, container_2: string) {
  if (regex.test(field.value)) {
    set_field({...field, valid: true})
    legendIconValidRequired(identifier, container_1, container_2)
  } else {
    set_field({...field, valid: false})
    legendIconInvalidRequired(field.value, identifier, container_1, container_2)
  }
}

export function evaluateLegendObjectOptional(regex: RegExp, attribute: string, field: any, set_field: Dispatch<SetStateAction<any>>, container: string) {
  if (field.value[attribute].length === 0) {
    set_field({...field, valid: {...field.valid, [attribute]: true}})
    legendValidInvalidRestart(container)
  } else {
    if (regex.test(field.value[attribute])) {
      set_field({...field, valid: {...field.valid, [attribute]: true}})
      legendValid(container)
    } else {
      set_field({...field, valid: {...field.valid, [attribute]: false}})
      legendInvalid(container)
    }
  }
}

export function evaluateLegendObjectOptionalIcon(regex: RegExp, attribute: string, field: any, set_field: Dispatch<SetStateAction<any>>, identifier: string, container: string) {
  if (field.value[attribute].length === 0) {
    set_field({...field, valid: {...field.valid, [attribute]: true}})
    legendIconValidInvalidRestart(identifier, container)
  } else {
    if (regex.test(field.value[attribute])) {
      set_field({...field, valid: {...field.valid, [attribute]: true}})
      legendIconValid(identifier, container)
    } else {
      set_field({...field, valid: {...field.valid, [attribute]: false}})
      legendIconInvalid(identifier, container)
    }
  }
}

export function evaluateLegendObjectRequired(regex: RegExp, attribute: string, field: any, set_field: Dispatch<SetStateAction<any>>, container_1: string, container_2: string) {
  if (regex.test(field.value[attribute])) {
    set_field({...field, valid: {...field.valid, [attribute]: true}})
    legendValidRequired(container_1, container_2)
  } else {
    set_field({...field, valid: {...field.valid, [attribute]: false}})
    legendInvalidRequired(field.value[attribute], container_1, container_2)
  }
}

export function evaluateLegendObjectRequiredIcon(regex: RegExp, attribute: string, field: any, set_field: Dispatch<SetStateAction<any>>, identifier: string, container_1: string, container_2: string) {
  if (regex.test(field.value[attribute])) {
    set_field({...field, valid: {...field.valid, [attribute]: true}})
    legendIconValidRequired(identifier, container_1, container_2)
  } else {
    set_field({...field, valid: {...field.valid, [attribute]: false}})
    legendIconInvalidRequired(field.value[attribute], identifier, container_1, container_2)
  }
}

export function evaluateLegendObjectCompositeRequiredIcon(regex: RegExp, attribute: string, sub_attribute: string, field: any, set_field: Dispatch<SetStateAction<any>>, identifier: string, container_1: string, container_2: string) {
  if (regex.test(field.value[attribute][sub_attribute])) {
    set_field({...field, valid: {...field.valid, [attribute]: {...field.valid[attribute], [sub_attribute]: true}}})
    legendIconValidRequired(identifier, container_1, container_2)
  } else {
    set_field({...field, valid: {...field.valid, [attribute]: {...field.valid[attribute], [sub_attribute]: false}}})
    legendIconInvalidRequired(field.value[attribute][sub_attribute], identifier, container_1, container_2)
  }
}

export function evaluateLegendListRequired(regex: RegExp, index: number, field: any, set_field: Dispatch<SetStateAction<any>>, container_1: string, container_2: string) {
  if (regex.test(field.value[index])) {
    let list = field.valid.map((temp_item: boolean, temp_index: number) => {
      if (index === temp_index) {
        temp_item = true
      }
      return temp_item
    })
    set_field({...field, valid: list})
    legendValidRequired(container_1, container_2)
  } else {
    let list = field.valid.map((temp_item: boolean, temp_index: number) => {
      if (index === temp_index) {
        temp_item = false
      }
      return temp_item
    })
    set_field({...field, valid: list})
    legendInvalidRequired(field.value[index], container_1, container_2)
  }
}

export function evaluateLegendListObjectOptional(regex: RegExp, index: number, attribute: string, field: any, set_field: Dispatch<SetStateAction<any>>, container: string) {
  if (field.value[index][attribute].length === 0) {
    let list = field.valid.map((temp_item: any, temp_index: number) => {
      if (index === temp_index) {
        temp_item[attribute] = true
      }
      return temp_item
    })
    set_field({...field, valid: list})
    legendValidInvalidRestart(container)
  } else {
    if (regex.test(field.value[index][attribute])) {
      let list = field.valid.map((temp_item: any, temp_index: number) => {
        if (index === temp_index) {
          temp_item[attribute] = true
        }
        return temp_item
      })
      set_field({...field, valid: list})
      legendValid(container)
    } else {
      let list = field.valid.map((temp_item: any, temp_index: number) => {
        if (index === temp_index) {
          temp_item[attribute] = false
        }
        return temp_item
      })
      set_field({...field, valid: list})
      legendInvalid(container)
    }
  }
}

export function evaluateLegendListObjectRequired(regex: RegExp, index: number, attribute: string, field: any, set_field: Dispatch<SetStateAction<any>>, container_1: string, container_2: string) {
  if (regex.test(field.value[index][attribute])) {
    let list = field.valid.map((temp_item: any, temp_index: number) => {
      if (index === temp_index) {
        temp_item[attribute] = true
      }
      return temp_item
    })
    set_field({...field, valid: list})
    legendValidRequired(container_1, container_2)
  } else {
    let list = field.valid.map((temp_item: any, temp_index: number) => {
      if (index === temp_index) {
        temp_item[attribute] = false
      }
      return temp_item
    })
    set_field({...field, valid: list})
    legendInvalidRequired(field.value[index][attribute], container_1, container_2)
  }
}

export function evaluateLegendListObjectRequiredIcon(regex: RegExp, index: number, attribute: string, field: any, set_field: Dispatch<SetStateAction<any>>, identifier: string, container_1: string, container_2: string) {
  if (regex.test(field.value[index][attribute])) {
    let list = field.valid.map((temp_item: any, temp_index: number) => {
      if (index === temp_index) {
        temp_item[attribute] = true
      }
      return temp_item
    })
    set_field({...field, valid: list})
    legendIconValidRequired(identifier, container_1, container_2)
  } else {
    let list = field.valid.map((temp_item: any, temp_index: number) => {
      if (index === temp_index) {
        temp_item[attribute] = false
      }
      return temp_item
    })
    set_field({...field, valid: list})
    legendIconInvalidRequired(field.value[index][attribute], identifier, container_1, container_2)
  }
}

export function evaluateLegendMapObjectOptional(regex: RegExp, index: number, sub_index: number, attribute: string, field: any, set_field: Dispatch<SetStateAction<any>>, container: string) {
  if (field.value[index].contents[sub_index][attribute].length === 0) {
    let list = field.valid.map((temp_item: any, temp_index: number) => {
      if (index === temp_index) {
        temp_item.contents[sub_index][attribute] = true
      }
      return temp_item
    })
    set_field({...field, valid: list})
    legendValidInvalidRestart(container)
  } else {
    if (regex.test(field.value[index].contents[sub_index][attribute])) {
      let list = field.valid.map((temp_item: any, temp_index: number) => {
        if (index === temp_index) {
          temp_item.contents[sub_index][attribute] = true
        }
        return temp_item
      })
      set_field({...field, valid: list})
      legendValid(container)
    } else {
      let list = field.valid.map((temp_item: any, temp_index: number) => {
        if (index === temp_index) {
          temp_item.contents[sub_index][attribute] = false
        }
        return temp_item
      })
      set_field({...field, valid: list})
      legendInvalid(container)
    }
  }
}

export function evaluateLegendMapObjectRequired(regex: RegExp, index: number, sub_index: number, attribute: string, field: any, set_field: Dispatch<SetStateAction<any>>, container_1: string, container_2: string) {
  if (regex.test(field.value[index].contents[sub_index][attribute])) {
    let list = field.valid.map((temp_item: any, temp_index: number) => {
      if (index === temp_index) {
        temp_item.contents[sub_index][attribute] = true
      }
      return temp_item
    })
    set_field({...field, valid: list})
    legendValidRequired(container_1, container_2)
  } else {
    let list = field.valid.map((temp_item: any, temp_index: number) => {
      if (index === temp_index) {
        temp_item.contents[sub_index][attribute] = false
      }
      return temp_item
    })
    set_field({...field, valid: list})
    legendInvalidRequired(field.value[index].contents[sub_index][attribute], container_1, container_2)
  }
}
